export const downloadFile = (blob, filename) => {
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  }
};

export const downloadFileFromUrl = async (url, filename) => {
  const image = await fetch(url, {
    method: 'GET',
    withCredentials: true,
    crossorigin: true
  });

  const imageBlob = await image.blob();
  const imageUrl = URL.createObjectURL(imageBlob);

  let a = document.createElement('a');

  if (!filename) {
    filename = url.split('/').pop();
  }

  a.href = imageUrl;
  a.download = filename;
  a.target = '_blank';
  a.click();

  a = null;

  URL.revokeObjectURL(imageUrl);
};
